<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-3 ">
          <div><b>เลขที่คำสั่งซื้อ : OR65/000123</b></div>
          <v-form ref="form_order" @submit.prevent="send_data">
            <div class="grid_half">
              <div class="mt-3 mr-1">
                <v-text-field color="#86bc3a" label="ชื่อลูกค้า" prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกชื่อลูกค้า']" hide-details="auto" required  v-model="send_list.name" outlined></v-text-field>
              </div>
              <div class="mt-3 ml-1">
                <v-text-field color="#86bc3a" type="tel" maxlength="11" :rules="[v => !!v || 'กรุณากรอกเบอร์โทร']" @keypress="isNumber($event, send_list.telephone)" v-model="send_list.telephone" label="เบอร์โทร" required hide-details="auto" outlined></v-text-field>
              </div>
            </div>
            <div class="grid_half">
              <div class="mt-3 mr-1">
                <v-text-field color="#86bc3a" type="tel" maxlength="11" @keypress="isNumber($event, send_list.customer_personal_id)" v-model="send_list.customer_personal_id" label="เลขประจำตัวผู้เสียภาษี" hide-details="auto" outlined></v-text-field>
              </div>
            </div>
            <div class="grid_full">
              <div class="mt-3">
                <v-text-field class="mt-2" color="#86bc3a" placeholder="ที่อยู่" :rules="[v => !!v || 'กรุณากรอกที่อยู่']" prepend-inner-icon="mdi-home-outline" hide-details="auto" required v-model="send_list.address" outlined></v-text-field>
              </div>
            </div>
            <div class="grid_four pt-5">
              <div class="mt-3 mr-1">
                <addressinput-subdistrict :store="mainDataStore" class="custom_css" placeholder="ตำบล/แขวง" v-model="send_list.sub_district"/>
              </div>
              <div class="mt-3 ml-1 mr-1">
                <addressinput-district :store="mainDataStore" class="custom_css" placeholder="อำเภอ/เขต" v-model="send_list.district"/>
              </div>
              <div class="mt-3 ml-1 mr-1">
                <addressinput-province :store="mainDataStore" class="custom_css" placeholder="จังหวัด" v-model="send_list.province" />
              </div>
              <div class="mt-3 ml-1">
                <addressinput-zipcode numbered :store="mainDataStore" class="custom_css" placeholder="รหัสไปรษณีย์" v-model="send_list.postcode" />
              </div>
            </div>
            <div class="grid_delivery">
              <span class="pl-2 mt-5">การจัดส่ง</span>
              <div class="grid_delivery">
                <v-radio-group v-model="send_list.delivery_type" @change="deliveryType()" mandatory>
                  <div class="d-flex justify-space-around">
                    <div class="d-flex mr-1">
                      <div>
                        <v-radio color="#86bc3a" :value="0"></v-radio>
                      </div>
                      <div>รับที่ร้าน</div>
                    </div>
                    <div class="d-flex ml-1">
                      <div>
                        <v-radio color="#86bc3a" :value="1"></v-radio>
                      </div>
                      <div>ส่งพัสดุ</div>
                    </div>
                  </div>
                </v-radio-group>
              </div>
            </div>
            <div class="pt-5">
              <span>รายการสินค้า</span>
              <div class="mt-3 mr-1">
                <v-autocomplete color="#86bc3a" @input="append_data(send_list.product_id)" :items="items" item-text="name" item-value="id" v-model="send_list.product_id" label="ค้นหารายการสินค้า" prepend-inner-icon="mdi-cart-outline" hide-details="auto" outlined></v-autocomplete>
              </div>
            </div>
            <div class="pt-5">
              <v-data-table :headers="header" :items="data_list" key="index" :items-per-page="item_page" :footer-props="footer_Props" mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td>{{ dataDetail.item.name }}</td>
                    <td class="pa-3">
                      <v-select color="#86bc3a" :items="dataDetail.item.product_lists"  @change="prepare_lots(dataDetail.item.loop_id, dataDetail.item.unit_id)" item-text="name" item-value="id" label="หน่วยนับ" v-model="dataDetail.item.unit_id" hide-details="auto" outlined></v-select>
                    </td>
                    <td>
                      <div v-if="dataDetail.item.retail_price !== null">{{dataDetail.item.retail_price}}</div>
                      <div v-else>0.00</div>
                    </td>
                    <td>
                      <v-text-field color="#86bc3a" type="number" @input="checkMax_value()" @keypress="onlyNumber($event, dataDetail.item.qty)" label="จำนวน" :rules="[v => !!v || 'กรุณากรอกจำนวน']" v-model="dataDetail.item.qty" hide-details="auto" required outlined></v-text-field>
                    </td>
                    <td>
                      {{ format_price(dataDetail.item.total = dataDetail.item.retail_price * dataDetail.item.qty) }}
                    </td>
                    <td class="pa-3">
                      <v-btn small type="button" height="42" @click="getDelete(dataDetail.item.loop_id)" class="grad-danger-bg white--text mb-1">
                        <v-icon>mdi-delete-empty-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <v-simple-table class="mt-3">
                <tbody>
                  <tr>
                    <td class="border_header" align="right" width="80%">ส่วนลดท้ายบิล</td>
                    <td class="border_header" align="center" width="20%">
                      <v-text-field class="discount_input" color="#86bc3a" type="tel" @keypress="isNumber($event)" v-model="discount" hide-details="auto" outlined dense></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="border_header" align="right" width="80%">ค่าจัดส่ง</td>
                    <td class="border_header" align="center" width="20%">{{ format_price(delivery_price) }}</td>
                  </tr>
                  <tr>
                    <td class="border_header" align="right" width="80%">รวมทั้งหมด</td>
                    <td class="border_header"  align="center" width="20%">{{ format_price(total + parseFloat(delivery_price)) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
              
            </div>
            <div class="text-center">
              <v-btn x-large type="submit" class="grad-success-bg white--text btn_mobile" style="font-size: 18px">บันทึกคำสั่งซื้อใหม่</v-btn>
            </div>
          </v-form>
        </div>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import {formatPrice, isTelephone, onlyForNumber} from "@/js/handler";
import {DataStore} from "vue-thailand-address";
import Swal from "sweetalert2";
import {HTTP} from "@/axios";
const mainDataStore = new DataStore();

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Create_order_other",
  data() {
    return {
      loading_page: false,
      mainDataStore,
      overlay: false,
      item_page: -1,
      alert_success: false,
      alert_danger: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      send_list: {
        telephone: '',
        customer_personal_id: '',
        name: '',
        delivery_type: 0,
        address: '',
        sub_district: '',
        district: '',
        province: '',
        postcode: '',
        product_id: null,
      },
      items: [],
      header: [
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          fixed: true,
          width: '275px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '125px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'retail_price',
          fixed: true,
          width: '145px',
        },
        {
          text: 'จำนวน',
          value: 'qty',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          sortable: false,
          fixed: true,
          width: '125px',
        },
        {
          text: '',
          value: '',
          sortable: false,
          fixed: true,
          width: '100px',
        },
      ],
      data_list: [],
      loop_id: 0,
      discount: null,
      weight_list:[],
      delivery_price: 0,
    }
  },
  methods: {
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    onlyNumber: function(evt) {
      return onlyForNumber(evt)
    },
    format_price: function(value) {
      return formatPrice(value)
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/neworders/allproducts')
          .then((res) => {
            if (res.data.success === true) {
              this.items = res.data.object
              // this.loading_page = false
              this.get_price_rate()
            }
          })
    },
    async get_price_rate() {
      let weight_arr = []
      await HTTP.get('wholesales/price_rate')
          .then((res) => {
            if (res.data.success === true) {
              res.data.price_rate.forEach((data) => {
                weight_arr.push({
                  id: data.id,
                  rate_end: data.rate_end !== null ? data.rate_end : '0.00',
                  rate_price: data.rate_price,
                  rate_start: data.rate_start !== null ? data.rate_start : '0.00',
                  rate_type: data.rate_type,
                })
              })
              this.weight_list = weight_arr
              this.loading_page = false
            }
          })
    },
    deliveryType(){
      const result = this.data_list.reduce((sum,number) => {
        let value = number.product_lists.find(detail => {
          return detail.id == number.unit_id
        })
        let qty = number.qty
        if (!number.qty) {
          qty = 0
        }
        let total_weight = parseFloat(qty) * parseFloat(value.weight)
        if (total_weight < 0) {
          return sum+(0)
        }
        else {
          return sum+parseFloat(total_weight);
        }
      }, 0)

      let math_weight = parseFloat(result)
      if (math_weight !== 0) {
        let result_weight = null
        this.weight_list.forEach((data) => {
          if (data.rate_type == 1 && math_weight >= parseFloat(data.rate_start) && math_weight <= parseFloat(data.rate_end)) {
              result_weight = data
              return
          }else if(data.rate_type == 2 && math_weight <= parseFloat(data.rate_start)){
              result_weight = data
              return
          }else if(data.rate_type == 3 && math_weight >= parseFloat(data.rate_start)){
              result_weight = data
              return
          }
        })
        this.delivery_price = result_weight.rate_price
      }
      else {
        this.delivery_price = 0
      }

      if (this.send_list.delivery_type == 0) {
        this.delivery_price = 0
      }
    },
    checkMax_value() {
      const result = this.data_list.reduce((sum,number) => {
        let value = number.product_lists.find(detail => {
          return detail.id == number.unit_id
        })
        let qty = number.qty
        if (!number.qty) {
          qty = 0
        }
        let total_weight = parseFloat(qty) * parseFloat(value.weight)
        if (total_weight < 0) {
          return sum+(0)
        }
        else {
          return sum+parseFloat(total_weight);
        }
      }, 0)

      let math_weight = parseFloat(result)
      if (math_weight !== 0) {
        let result_weight = null
        this.weight_list.forEach((data) => {
          if (data.rate_type == 1 && math_weight >= parseFloat(data.rate_start) && math_weight <= parseFloat(data.rate_end)) {
              result_weight = data
              return
          }else if(data.rate_type == 2 && math_weight <= parseFloat(data.rate_start)){
              result_weight = data
              return
          }else if(data.rate_type == 3 && math_weight >= parseFloat(data.rate_start)){
              result_weight = data
              return
          }
        })
        this.delivery_price = result_weight.rate_price
      }
      else {
        this.delivery_price = 0
      }

      if (this.send_list.delivery_type == 0) {
        this.delivery_price = 0
      }
    },
    async append_data(id) {
      let value = this.items.filter((data) => data.id === id)
      value.forEach((data) => {
        let loop_id = this.loop_id += 1
        this.data_list.push({
          loop_id: loop_id,
          id: data.id,
          name: data.name,
          unit_id: data.productlists[0].unit_id,
          retail_price: data.productlists[0].retail_price,
          product_lists: data.productlists.map((data) => {return {id: data.unit_id, name: data.name, retail_price: data.retail_price, weight:data.weight}}),
          qty: '',
          total: '',
        })
      })
      await this.$nextTick(() => {
        this.send_list.product_id = null
        this.alert_success = true
        setTimeout(() => this.alert_success = false, 2000)
      })
    },
    prepare_lots(loop_id, unit_id) {
      const key = loop_id
      this.data_list.forEach((data) => {
        if (key === data.loop_id) {
          const set_list = data.product_lists.filter(data => data.id === unit_id)
          data.retail_price = set_list[0].retail_price
        }
      })

      const result = this.data_list.reduce((sum,number) => {
        let value = number.product_lists.find(detail => {
          return detail.id == number.unit_id
        })
        let qty = number.qty
        if (!number.qty) {
          qty = 0
        }
        let total_weight = parseFloat(qty) * parseFloat(value.weight)
        if (total_weight < 0) {
          return sum+(0)
        }
        else {
          return sum+parseFloat(total_weight);
        }
      }, 0)

      let math_weight = parseFloat(result)
      if (math_weight !== 0) {
        let result_weight = null
        this.weight_list.forEach((data) => {
          if (data.rate_type == 1 && math_weight >= parseFloat(data.rate_start) && math_weight <= parseFloat(data.rate_end)) {
              result_weight = data
              return
          }else if(data.rate_type == 2 && math_weight <= parseFloat(data.rate_start)){
              result_weight = data
              return
          }else if(data.rate_type == 3 && math_weight >= parseFloat(data.rate_start)){
              result_weight = data
              return
          }
        })
        this.delivery_price = result_weight.rate_price
      }
      else {
        this.delivery_price = 0
      }

      if (this.send_list.delivery_type == 0) {
        this.delivery_price = 0
      }
    },
    getDelete(loop_id) {
      this.data_list = this.data_list.filter((data) => data.loop_id !== loop_id)

      const result = this.data_list.reduce((sum,number) => {
        let value = number.product_lists.find(detail => {
          return detail.id == number.unit_id
        })
        let qty = number.qty
        if (!number.qty) {
          qty = 0
        }
        let total_weight = parseFloat(qty) * parseFloat(value.weight)
        if (total_weight < 0) {
          return sum+(0)
        }
        else {
          return sum+parseFloat(total_weight);
        }
      }, 0)

      let math_weight = parseFloat(result)
      if (math_weight !== 0) {
        let result_weight = null
        this.weight_list.forEach((data) => {
          if (data.rate_type == 1 && math_weight >= parseFloat(data.rate_start) && math_weight <= parseFloat(data.rate_end)) {
              result_weight = data
              return
          }else if(data.rate_type == 2 && math_weight <= parseFloat(data.rate_start)){
              result_weight = data
              return
          }else if(data.rate_type == 3 && math_weight >= parseFloat(data.rate_start)){
              result_weight = data
              return
          }
        })
        this.delivery_price = result_weight.rate_price
      }
      else {
        this.delivery_price = 0
      }

      if (this.send_list.delivery_type == 0) {
        this.delivery_price = 0
      }

      this.alert_danger = true
      setTimeout(() => this.alert_danger = false, 2000)
    },
    send_data() {
      if (this.$refs.form_order.validate()) {
        Swal.fire({
          text: 'ต้องการดำเนินการต่อหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            if (this.data_list.length > 0) {
              this.overlay = true
              HTTP.post('/neworders/create', {
                user_id: this.$store.state.userDetail.id,
                user_name: this.$store.state.userDetail.name,
                customer_name: this.send_list.name,
                telephone: this.send_list.telephone,
                customer_personal_id: this.send_list.customer_personal_id,
                delivery_type: this.send_list.delivery_type,
                address: this.send_list.address,
                sub_district: this.send_list.sub_district,
                district: this.send_list.district,
                province: this.send_list.province,
                postcode: this.send_list.postcode,
                data_list: this.data_list,
                discount:this.discount,
                delivery_price:this.delivery_price,
                total: parseFloat(this.total) + parseFloat(this.delivery_price),
              }).then((res) => {
                if (res.data.success === true) {
                  this.$router.push('/sell/orderothermain')
                }
              })
            }
            else {
              Swal.fire({
                text: 'กรุณาเลือกสินค้า !',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              })
            }
          }
        })
      }  
     },
  },
  computed:{
    total(){
      const result = this.data_list.reduce((sum,number) => {
        return sum+number.total
      }, 0) - this.discount
      return result
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.grid_four {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
.grid_delivery {
  display: grid;
  grid-template-columns: 50%;
}
.custom_css >>> input {
  font-size: 18px;
  border-color: #9b9b9b;
  border-radius: 5px;
  padding: 16px;
  height: 56px !important;
}
.custom_css >>> input:hover {
  border-color: black;
}
.custom_css >>> input:focus {
  border-color: #8cc63e !important;
  border: solid 2px;
  padding: 15px;
}
.custom_css >>> ul {
  max-height: 200px;
  list-style: none;
  margin: 0;
  overflow-y: auto;
  padding: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
  font-size: 16px;
}
.border_header {
    border: thin solid rgba(0, 0, 0, 0.12);
}
@media only screen and (max-width: 1440px) {
  .custom_css >>> ul {
    max-height: 200px;
    list-style: none;
    margin: 0;
    overflow-y: auto;
    padding: 0;
    position: absolute;
    width: 100%;
    z-index: 1;
    font-size: 14px;
  }
}
@media only screen and (max-width: 1180px) {
  .grid_four {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_four {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_delivery {
    display: grid;
    grid-template-columns: 100%;
  }
  .btn_mobile {
    width: 100%;
  }
}

.discount_input >>> input {
    text-align: center!important;
}
</style>
